import { PlanSyncStatus } from '../types/plans.types';
import type { StatusVariant } from '@/shared/components/ui/status-badge';

/**
 * Los cuatro estados de sincronización caen exactamente en las cuatro variantes de
 * `StatusBadge`, así que no hace falta un badge propio.
 */
const SYNC_STATUS_VARIANT: Record<PlanSyncStatus, StatusVariant> = {
  [PlanSyncStatus.Synced]: 'active',
  [PlanSyncStatus.Pending]: 'warning',
  [PlanSyncStatus.NotSynced]: 'inactive',
  [PlanSyncStatus.Failed]: 'error',
};

const SYNC_STATUS_LABEL: Record<PlanSyncStatus, string> = {
  [PlanSyncStatus.Synced]: 'Sincronizado',
  [PlanSyncStatus.Pending]: 'Sincronizando',
  [PlanSyncStatus.NotSynced]: 'Sin sincronizar',
  [PlanSyncStatus.Failed]: 'Error de sincronización',
};

export const getSyncStatusVariant = (status: PlanSyncStatus): StatusVariant =>
  SYNC_STATUS_VARIANT[status] ?? 'inactive';

export const getSyncStatusLabel = (status: PlanSyncStatus): string =>
  SYNC_STATUS_LABEL[status] ?? status;

const VISIBILITY_LABEL: Record<string, string> = {
  Public: 'Público',
  Private: 'Privado',
};

export const getVisibilityLabel = (visibility: string): string =>
  VISIBILITY_LABEL[visibility] ?? visibility;

const currencyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
});

export const formatPlanPrice = (amount: number): string => currencyFormatter.format(amount);
